import { useEffect, useState } from 'react';
import { PRIORITIES } from '../../lib/todos';

const BLANK = {
  title: '',
  notes: '',
  assignedTo: '',
  dueDate: '',
  priority: 'Normal',
};

export default function TodoForm({ initialTodo, profiles, submitLabel = 'Add task', onSubmit, onCancel }) {
  const [title, setTitle] = useState(BLANK.title);
  const [notes, setNotes] = useState(BLANK.notes);
  const [assignedTo, setAssignedTo] = useState(BLANK.assignedTo);
  const [dueDate, setDueDate] = useState(BLANK.dueDate);
  const [priority, setPriority] = useState(BLANK.priority);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (initialTodo) {
      setTitle(initialTodo.title);
      setNotes(initialTodo.notes || '');
      setAssignedTo(initialTodo.assigned_to || '');
      setDueDate(initialTodo.due_date || '');
      setPriority(initialTodo.priority);
    } else {
      setTitle(BLANK.title);
      setNotes(BLANK.notes);
      setAssignedTo(BLANK.assignedTo);
      setDueDate(BLANK.dueDate);
      setPriority(BLANK.priority);
    }
    setError(null);
  }, [initialTodo]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await onSubmit({
        title,
        notes: notes || null,
        assigned_to: assignedTo || null,
        due_date: dueDate || null,
        priority,
      });
      if (!initialTodo) {
        setTitle(BLANK.title);
        setNotes(BLANK.notes);
        setAssignedTo(BLANK.assignedTo);
        setDueDate(BLANK.dueDate);
        setPriority(BLANK.priority);
      }
    } catch (submitError) {
      setError(submitError.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form className="todo-form" onSubmit={handleSubmit}>
      <div className="todo-form-grid">
        <label className="todo-form-wide">
          Task
          <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} required />
        </label>

        <label>
          Assign to
          <select value={assignedTo} onChange={(e) => setAssignedTo(e.target.value)}>
            <option value="">Unassigned</option>
            {profiles.map((p) => (
              <option key={p.id} value={p.id}>
                {p.display_name || p.email}
              </option>
            ))}
          </select>
        </label>

        <label>
          Due date (optional)
          <input type="date" value={dueDate} onChange={(e) => setDueDate(e.target.value)} />
        </label>

        <label>
          Priority
          <select value={priority} onChange={(e) => setPriority(e.target.value)}>
            {PRIORITIES.map((p) => (
              <option key={p} value={p}>
                {p}
              </option>
            ))}
          </select>
        </label>

        <label className="todo-form-wide">
          Notes (optional)
          <input type="text" value={notes} onChange={(e) => setNotes(e.target.value)} />
        </label>
      </div>

      {error && <p className="todo-form-error">{error}</p>}

      <div className="todo-form-actions">
        <button type="submit" disabled={submitting}>
          {submitting ? 'Saving…' : submitLabel}
        </button>
        {onCancel && (
          <button type="button" className="todo-form-cancel" onClick={onCancel}>
            Cancel
          </button>
        )}
      </div>
    </form>
  );
}
